import { render, staticRenderFns } from "./EmployerGroupPlans.vue?vue&type=template&id=127167a5&"
import script from "./EmployerGroupPlans.vue?vue&type=script&lang=js&"
export * from "./EmployerGroupPlans.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/employer-groups.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports